/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from "@reduxjs/toolkit";
import CalendarService from "@/services/CalendarService";

const handler = (name, asyncFunction) =>
  createAsyncThunk(`calendar/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getDayHours = handler(
  "getDayHours",
  CalendarService.getPropertySchedule
);
export const getMonthAvailableDays = handler(
  "getMonthAvailableDays",
  CalendarService.getPropertySchedule
);
export const getVisitData = handler(
  "getVisitData",
  CalendarService.getVisitData
);
export const confirmVisit = handler(
  "confirmVisit",
  CalendarService.confirmVisit
);
export const cancelVisit = handler(
  "cancelVisit",
  CalendarService.cancelVisit
);
